<template>
  <v-container fluid class="fabill-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <v-btn to="/fabill/add" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" @click="isFindFABill=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn color="primary" class="button-shadow mr-2" @click="makePaymentList">
                <v-icon class="mr-2">mdi-cash-plus</v-icon>
                Pay
              </v-btn>

              <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="csv"
                :name="getFileName()"
              >
              <v-btn 
                v-show="data_fabills.length>0"
                color="default" 
                class="button-shadow mb-2 mr-1 mr-sm-1"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel>
              <v-btn to="/batchpayment/list" color="default" class="button-shadow ml-1 mr-1">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Payments
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              item-key="_id"
              v-model="data_selected"
              loading-text="Loading... Please wait"
              class="fabills-table"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="header_fabill"
              :items="data_fabills"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Bill?
                    </v-card-title>
                    <v-card-text>
                      {{ deletefabill.fabillnum }} 
                      {{ deletefabill.assetname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deletefabill)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userid="{ item }">
                <div v-if="item.userid!=undefined">
                  <p class="two-line">
                    <v-avatar v-if="users.length>0 && users.find(user=>user._id == item.userid)['userimage']!==''" size="40">
                      <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                    </v-avatar>
                    <v-avatar
                      v-else
                      color="warning"
                      size="40">
                      <span class="white--text headline">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'][0].toUpperCase() : '' }}</span>
                    </v-avatar>
                  </p>
                  <p class="two-line">
                    <span style="margin-left:0px; font-size: 9pt;">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span>
                  </p>
                </div>
              </template>
              <template v-slot:item.fabillimage="{ item }">
                    <v-img
                    v-if="item.fabillimage" 
                    v-bind:src="item.fabillimage"
                    max-height="60"
                    max-width="60"
                  ></v-img>
              </template>
              <template v-slot:item.isTaxable="{ item }">
                <v-icon v-if="item.isTaxable==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.fabillnum="{ item }">
                <p class="two-line">{{ item.assettype  }} {{ item.assetnum  }}</p>
                <p v-if="item.assetdate!=undefined" class="two-line">{{ new Date(item.assetdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
                <p v-if="item.assetstartdate!==undefined" class="two-line"><b>Start: {{ new Date(item.assetstartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</b></p>
              </template>
              <template v-slot:item.payments="{ item }">
                <div v-if="item.payments" style="font-size: 10pt;">{{ item.payments.map(item=>new Date(item.transdate).toLocaleString("en-SG", { year: '2-digit', month: '2-digit', day: 'numeric' }) + ':&nbsp;&nbsp;' + `$${item.transamount.toFixed(2)}`).join('\n') }}</div>
              </template>
              <template v-slot:item.depreciations="{ item }">
                <div v-if="item.depreciations">{{ item.depreciations.reduce((a, b) => a + b.transamount, 0).toFixed(2) }}</div>
              </template>
              <template v-slot:item.assetname="{ item }">
                <p class="two-line" style="font-size: 9pt;">{{ item.assetname }}</p>
                <p class="two-line" style="font-size: 9pt;"><span style="font-size: 9pt; font-weight: bold;">Ref:</span> {{ item.refnum }}</p>
                <p class="two-line" v-if="item.channelid!=undefined"  style="font-size: 10pt;">{{ saleschannels.length>0 ? saleschannels.find(channel=>channel._id == item.channelid)['channelname'] : ''  }}</p>
              </template>
              <template v-slot:item.assettotal="{ item }">
                <p v-if="item.primaryCurrency" class="two-line"><span style="font-size: x-small;">{{ item.primaryCurrency }}</span> {{ item.assettotal.toFixed(2).toLocaleString('en-SG') }}</p>
                <p v-if="item.primaryCurrency!=item.secondaryCurrency" class="two-line"><span style="font-size: x-small;">{{ item.secondaryCurrency }}</span> {{ (item.assettotal * item.currencyRate).toFixed(2).toLocaleString('en-SG') }}</p>
              </template>
              <template v-slot:item.assetstatus="{ item }">
                <v-chip
                  v-if="item.assetstatus!=undefined"
                  :color="getStatusColor(item.assetstatus)"
                  small
                >
                  {{ item.assetstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editBill(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.assetstatus=='New'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="isFindFABill"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find FA Bills</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    :items="locations.filter(x=>x.locationstatus=='Active').map(x => {
                              return {text: x.locationname, value: x._id};
                            })"
                    v-model="find_query.locationid"
                    label="Location"
                    required
                    dense
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-select
                    :items="saleschannels.filter(x=>x.channelstatus=='New').map(x => {
                              return {text: x.channelname, value: x._id};
                            })"
                    v-model="find_query.channelid"
                    label="Channel"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="12">
                  <v-select
                    :items="vendors.filter(x=>x.vendorstatus=='Active').map(x => {
                              return {text: x.vendorname, value: x._id};
                            })"
                    v-model="find_query.vendorid"
                    label="Vendor"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-select
                    :items="['Current Asset', 'Fixed Asset', 'Intangible Asset']"
                    v-model="find_query.assettype"
                    label="FABill Type"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-select
                    :items="['New', 'Pending', 'Partial', 'Completed', 'Audit', 'Void']"
                    v-model="find_query.assetstatus"
                    label="FABill Status"
                    required
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field
                    class="mb-4"
                    type="number"
                    placeholder="FABill Num"
                    v-model="find_query.fabillnum"
                    dense
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="FABill Num">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menu_startdate"
                            v-model="menu_startdate"
                            :close-on-content-click="false"
                            :return-value.sync="find_query.startdate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                v-model="find_query.startdate"
                                label="Start Date"
                                v-bind="attrs"
                                v-bind:value="find_query.startdate"
                                v-on="on"
                                persistent-hint
                                single-line hint="Please enter start date">
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="find_query.startdate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu_startdate = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu_startdate.save(find_query.startdate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                          <v-menu
                            ref="menu_enddate"
                            v-model="menu_enddate"
                            :close-on-content-click="false"
                            :return-value.sync="find_query.enddate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                dense
                                v-model="find_query.enddate"
                                label="End Date"
                                v-bind="attrs"
                                v-bind:value="find_query.enddate"
                                v-on="on"
                                persistent-hint
                                single-line hint="Please enter end date">
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="find_query.enddate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu_enddate = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu_enddate.save(find_query.enddate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindFABill = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetFABills"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findFABills"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  <div class="text-center">
    <v-dialog
      v-model="dialogAlert"
      width="300"
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">Error</v-card-title>
        <v-card-text>
          {{ dialogMessage }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialogAlert = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from '@/util/tools';

export default {
  name: 'FABillList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      dialogAlert: false,
      dialogMessage: '',
      isFindFABill: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      deletefabill: {},
      find_query: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      header_fabill: [
        { text: 'Bill', value: 'fabillnum', sortable: false, width: '12%' },
        { text: 'Name', value: 'assetname' },
        { text: 'Amount', value: 'assettotal', width: "10%" },
        { text: 'Paid', value: 'payments', width: "10%" },
        { text: 'Depreciation', value: 'depreciations', width: "12%" },
        { text: 'Create By', value: 'userid', width: '10%' },
        { text: 'Status', value: 'assetstatus', width: '10%' },
        { text: 'Tax', value: 'isTaxable', width: "2%" },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      data_fabills: [],
      data_selected: [],
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('FABill', ['fabills', 'query', 'isReceiving', 'isDeleting', 'idToDelete', 'fabillsMessage', 'isUpdating']),
    ...mapState('Department', ['departments']),
    ...mapState('Location', ['locations']),
    ...mapState('Vendor', ['vendors']),
    ...mapState('SalesChannel', ['saleschannels']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('FABill', ["getFABillsRequest", "findFABillsRequest", "deleteFABillRequest","updateFABillRequest","createFABillRequest"]),
    ...mapActions('Department', ["getDepartmentsRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('Vendor', ["getVendorsRequest"]),
    ...mapActions('SalesChannel', ["getSalesChannelsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    getJson(){
      let json = this.data_fabills.map(fabill=>{return {
        asset_num: fabill.assetnum, 
        asset_date: fabill.assetdate!=undefined ? new Date(fabill.assetdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        service_date: fabill.assetdate!=undefined ? new Date(fabill.assetstartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        asset_type: fabill.assettype,
        asset_name: fabill.assetname,
        reference: fabill.refnum,
        location: fabill.locationid!=undefined && this.locations.length>0 ? this.locations.find(location=>location._id == fabill.locationid)['locationname'] : '',
        channel: fabill.channelid!=undefined && this.saleschannels.length>0 ? this.saleschannels.find(channel=>channel._id == fabill.channelid)['channelname'] : '',
        total: fabill.assettotal,
        currency: fabill.primaryCurrency,
      }});
      return json;
    },
    checkError(){
      if(this.data_selected.length==0) return false;
      if(this.data_selected.find(item=>item.assetstatus=='Completed')!=null) return false;
      return true;
    },
    checkFABills(){
      return this.data_selected.filter(item=>item.assetstatus=='Completed').map(item=>item.fabillnum.toString()).join(', ');
    },
    getFileName(){
      var d = new Date();
      var name = 'asset_list-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.csv';
    },
    makePaymentList(){
      if(!this.checkError()) {
        if(this.data_selected.length==0) this.dialogMessage='No Bills selected';
        else this.dialogMessage='The following Bills cannot be paid:  ' + this.checkFABills();
        this.dialogAlert=true; 
        return;
      }
      let bills = Object.assign([], this.data_selected);
      let json = {bills: bills, isFABills: true};
      json['_isFrom'] = this.$route.name;
      this.$router.push({ name: 'BatchPaymentAdd', params: json });
    },
    editBill(item) {
      this.$router.push({ name: 'FABillEdit', params: item });
    },
    printItem(item) {
      this.$router.push({ name: 'FABillPrint', params: item });
    },
    viewItem(item) {
      this.$router.push({ name: 'FABillView', params: item });
    },
    async findFABills(){
      this.isFindFABill = false;
      if(Object.keys(this.find_query).length==0){
        await this.getFABillsRequest();
        this.data_fabills = Object.assign([], this.fabills);
      }
      else{
        let result = await this.findFABillsRequest(this.find_query);
        this.data_fabills = Object.assign([], result);
      }
    },
    async resetFABills(){
      this.find_query = {};

    },
    async deleteItem(item) {
      await this.deleteFABillRequest({_id: item._id});
      this.data_fabills = this.fabills;
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletefabill = {
        _id: item._id,
        fabillnum: item.fabillnum,
        assetname: item.assetname,
      }
    },
  },
  async created () {
    if(this.fabills.length==0) await this.getFABillsRequest();
    this.data_fabills = Object.assign([], this.fabills);
    if(this.$route.params.fabills!=null) this.data_selected = Object.assign([], this.$route.params.fabills);
    // if(this.query==null){
    //   await this.getFABillsRequest();
    //   this.data_fabills = Object.assign([], this.fabills);
    // }
    // else {
    //   this.find_query = Object.assign({}, this.query)
    //   let result = await this.findFABillsRequest(this.query);
    //   this.data_fabills = Object.assign([], result);
    // }


    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.departments.length==0) await this.getDepartmentsRequest();
    if(this.vendors.length==0) await this.getVendorsRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
